const configuredApiBase = String(process.env.REACT_APP_API_BASE || '').trim().replace(/\/+$/, '');

export function apiUrl(path) {
  const value = String(path || '');
  if (/^https?:\/\//i.test(value)) return value;
  const normalizedPath = value.startsWith('/') ? value : `/${value}`;
  return `${configuredApiBase}${normalizedPath}`;
}

export function getApiBase() {
  return configuredApiBase;
}
